'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { HelpCircle, Globe, ClipboardCheck, Footprints, ArrowRight } from 'lucide-react';
import { HomeSectionLayout } from './HomeSectionLayout';

// --- Data ---

const stages = [{
  icon: HelpCircle,
  title: 'Should you export?',
  description: 'Determine if you really do want to export and if exporting is right for your business.',
  color: 'bg-emerald-50 text-emerald-600'
}, {
  icon: Globe,
  title: 'What are the right markets?',
  description: 'Identify the best-fit markets for your products',
  color: 'bg-blue-50 text-blue-600'
}, {
  icon: ClipboardCheck,
  title: 'Strategy & Plan',
  description: 'Assess your current readiness and what you need to do to be ready, connect with the right experts and partners to execute.',
  color: 'bg-amber-50 text-amber-600'
}, {
  icon: Footprints,
  title: 'Execute with the right help',
  description: 'Put your plan into action with confidence and the support of the right NZ and in-market experts and partners.',
  color: 'bg-purple-50 text-purple-600'
}];
const SpecificScenariosItems = [{
  label: 'Funding orders',
  href: '/export'
}, {
  label: 'Unsure which markets are a good fit',
  href: '/export'
}];

// --- Sub-components ---

function ExportStages() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">{stages.map(_temp)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(stage) {
  return <div key={stage.title} className="relative rounded-xl border border-gray-200 bg-white p-6 hover:shadow-md transition-shadow"><h3 className="text-xl font-semibold text-gray-900 mb-1">{stage.title}</h3><p className="text-sm text-gray-600 leading-relaxed">{stage.description}</p></div>;
}
function SpecificScenario() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h4 className="text-center text-sm font-medium text-gray-500 uppercase tracking-wide mb-4">Specific scenarios we can help with?</h4>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mt-10">{t0}<div className="flex flex-wrap justify-center gap-3">{SpecificScenariosItems.map(_temp2)}</div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp2(challenge) {
  return <Link key={challenge.label} href={challenge.href} className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full border border-gray-200 bg-white text-sm text-gray-700 hover:border-primary-300 hover:text-primary-700 hover:bg-primary-50 transition-colors cursor-pointer">{challenge.label}<ArrowRight className="w-3.5 h-3.5" /></Link>;
}
function ExportCTA() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mt-10 text-center"><Link href="/export" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-600 text-white font-semibold shadow-md hover:bg-primary-700 hover:shadow-lg transition-all duration-200 cursor-pointer">Export Central <ArrowRight className="w-5 h-5" /></Link></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}

// --- Main component ---

interface ExportSectionProps {
  showSpecificScenarios?: boolean;
}
export function ExportSection(t0) {
  const $ = _c(6);
  const {
    showSpecificScenarios: t1
  } = t0;
  const showSpecificScenarios = t1 === undefined ? true : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ExportStages />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== showSpecificScenarios) {
    t3 = showSpecificScenarios && <SpecificScenario />;
    $[1] = showSpecificScenarios;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ExportCTA />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3) {
    t5 = <HomeSectionLayout title="Export To The World" subtitle="Navigate your Export journey more easily and successfully.">{t2}{t3}{t4}</HomeSectionLayout>;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}